<template>
  <div class="container-fluid cluster-page">
    <!-- justify-content-between -->
    <!-- fixed-content -->
    <div class="row">
      <!-- style="margin-left: 13px" -->
      <div class="col-3">
        <Datepicker
          class="datepicker-here form-control digits"
          id="dateRange"
          v-model="dateRange"
          @update:model-value="handleDate"
          :enable-time-picker="false"
          :format="formatDateRange"
          range
          placeholder="Select date"
        ></Datepicker>
      </div>
      <div class="col-3">
        <div class="dropdown">
          <button
            class="btn dropdown-toggle"
            id="clusterOptions"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {{ rangeSelected === "" ? "Select Cluster" : rangeSelected }}
          </button>
          <div
            class="dropdown-menu dropdown-menu-end"
            aria-labelledby="clusterOptions"
          >
            <a
              v-for="option in rangeOptions"
              :key="option"
              class="dropdown-item"
              :class="option === rangeSelected ? ' active' : ''"
              @click="rangeSelected = option"
              href="javascript:void(0)"
              >{{ option }}</a
            >
          </div>
        </div>
      </div>
      <div class="col"></div>
      <div class="col-3">
        <button class="btnAnalytics reportBtn" @click="downloadPDF()">
          <downloadIcon style="position: absolute; left: 25px"></downloadIcon>

          Generate Report
        </button>
      </div>
    </div>
    <br />
    <div class="loader-wrapper" v-if="loading">
      <div class="loader-index"><span></span></div>
      <svg>
        <defs></defs>
        <filter id="goo">
          <feGaussianBlur
            in="SourceGraphic"
            stddeviation="11"
            result="blur"
          ></feGaussianBlur>
          <feColorMatrix
            in="blur"
            values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9"
            result="goo"
          ></feColorMatrix>
        </filter>
      </svg>
    </div>
    <div id="pdf-content" ref="pdfContent">
      <div class="row section">
        <!-- margin-top: 0; -->
        <div class="col-3" style="height: 353px; z-index: 1">
          <div
            class="h-100 row justify-content-start align-content-start align-items-start"
          >
            <div class="col-12 m-0 g-4">
              <div class="large-card p-0">
                <div
                  class="total-cost position-relative d-flex flex-column justify-content-center align-items-center"
                >
                  <div class="total-cost_icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="36"
                      height="70"
                      viewBox="0 0 36 70"
                      fill="none"
                    >
                      <path
                        d="M17.5969 70C16.506 70 15.5923 69.6266 14.8556 68.88C14.119 68.1333 13.7493 67.2104 13.7468 66.1111V61.6389C10.8592 60.9907 8.32451 59.8565 6.14277 58.2361C3.96103 56.6157 2.19639 54.3472 0.848847 51.4305C0.399665 50.5231 0.384264 49.5678 0.802645 48.5644C1.22103 47.5611 1.97437 46.8313 3.06267 46.375C3.96103 45.9861 4.89148 46.003 5.85401 46.4255C6.81655 46.8481 7.55449 47.5443 8.06784 48.5139C9.15871 50.4583 10.5383 51.9335 12.2067 52.9394C13.8751 53.9454 15.9285 54.447 18.3669 54.4444C20.9979 54.4444 23.2271 53.8455 25.0546 52.6478C26.8821 51.45 27.7972 49.5859 27.7997 47.0555C27.7997 44.787 27.0939 42.9891 25.6822 41.6617C24.2705 40.3343 20.9978 38.8267 15.8643 37.1389C10.3458 35.3889 6.55987 33.2993 4.50647 30.87C2.45307 28.4407 1.42636 25.4748 1.42636 21.9722C1.42636 17.7593 2.77391 14.4861 5.469 12.1528C8.16409 9.81945 10.9233 8.49075 13.7468 8.16668V3.8889C13.7468 2.78705 14.1164 1.86279 14.8556 1.11612C15.5948 0.369457 16.5086 -0.00257914 17.5969 1.34564e-05C18.6852 0.00260605 19.6003 0.37594 20.342 1.12001C21.0838 1.86409 21.4522 2.78705 21.447 3.8889V8.16668C23.8854 8.55556 26.003 9.35019 27.7997 10.5506C29.5965 11.7509 31.0724 13.2248 32.2274 14.9722C32.8049 15.8148 32.9178 16.7546 32.5662 17.7917C32.2146 18.8287 31.492 19.5741 30.3986 20.0278C29.5002 20.4167 28.5698 20.4335 27.6072 20.0783C26.6447 19.7232 25.7463 19.0906 24.9121 18.1806C24.078 17.2706 23.0987 16.5744 21.9745 16.0922C20.8503 15.61 19.4552 15.3663 17.7894 15.3611C14.966 15.3611 12.8163 15.9937 11.3404 17.2589C9.86456 18.5241 9.12662 20.0952 9.12662 21.9722C9.12662 24.1111 10.0892 25.7963 12.0142 27.0278C13.9393 28.2593 17.2761 29.5556 22.0246 30.9167C26.4522 32.213 29.8057 34.2715 32.0849 37.0922C34.3642 39.913 35.5026 43.1693 35.5 46.8611C35.5 51.463 34.1525 54.963 31.4574 57.3611C28.7623 59.7592 25.4255 61.25 21.447 61.8333V66.1111C21.447 67.213 21.0774 68.1372 20.3382 68.8839C19.599 69.6305 18.6852 70.0026 17.5969 70Z"
                        fill="#218863"
                      />
                    </svg>
                  </div>
                  <h1 class="total-cost_value">RM {{ costSaving }}</h1>
                  <p class="total-cost_label">Cost Savings</p>
                  <p class="total-cost_label_small">(RM {{ tariff }} / kWh)</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col g-4" style="margin-top: 0; height: 353px; z-index: 1">
          <div
            class="row h-100"
            :class="{ 'row-cols-2': !lightPage, 'row-cols-1': lightPage }"
          >
            <div
              class="col-6"
              :class="{ 'col-12': lightPage }"
              v-for="(card, index) in cards"
              :key="index"
            >
              <div class="card card-small">
                <div class="card-body position-relative">
                  <div
                    v-if="card.showTooltip"
                    class="info"
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    title="The value calculated based on schedule for this month"
                  >
                    i
                  </div>
                  <div class="widget-content">
                    <div class="image">
                      <img
                        :src="require(`@/assets/images/icon/${card.img}.png`)"
                      />
                    </div>
                    <div>
                      <h4 class="title" v-html="titleHTML(card)"></h4>
                      <span class="subtitle">{{ card.subtitle }}</span>
                    </div>
                  </div>
                </div>
                <div v-if="card.value" class="card-footer">
                  <span @click="openLightModal">See All Streetlights >></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-3 g-4"
          :class="{ 'col-6': lightPage }"
          style="margin-top: 0; height: 353px; z-index: 1"
        >
          <div class="row h-100">
            <div class="col-12">
              <div
                class="large-card p-0 d-flex justify-content-center m-0"
                :class="{
                  'pt-4': !lightPage,
                  'flex-column': !lightPage,
                  row: lightPage,
                }"
              >
                <div
                  class="d-flex align-items-center"
                  :class="{
                    'col-4': lightPage,
                    'justify-content-center': !lightPage,
                    'justify-content-end': lightPage,
                  }"
                >
                  <!-- [10, 20, 40, 20, 30, 40, 10, 30, 50, 70] -->
                  <Doughnut
                    :caption="{
                      p1: 'Light Operating',
                      p2: 'Hours',
                    }"
                    :data="operatingHours"
                    :id="'analytics-vehicle-count'"
                  />
                </div>
                <div
                  class="d-flex align-items-center justify-content-center"
                  :class="{
                    'mt-2': !lightPage,
                    'col-3': lightPage,
                  }"
                >
                  <div
                    class="row d-flex justify-content-center mb-2 row-cols-2"
                    style="width: 150px; height: 102px"
                  >
                    <div
                      class="col d-flex justify-content-start align-items-center"
                      v-for="(item, index) in lightOperatingHours"
                      :key="index"
                    >
                      <roundIcon :fill="item.color"></roundIcon>

                      <span class="doughnut-legend">{{ item.value }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-4 section" v-if="$route.query.flag == 'cluster'">
        <div class="col-6 g-4">
          <div class="large-card">
            <VoltageChart :items="voltageChart" />
          </div>
        </div>
        <div class="col-6 g-4">
          <div class="large-card">
            <CurrentChart :items="currentChart" />
          </div>
        </div>
      </div>
      <div class="row mb-4 section" v-if="$route.query.flag == 'cluster'">
        <div class="col-12">
          <div class="large-card">
            <EnergyChart :items="energyChart" />
          </div>
        </div>
      </div>
      <div class="row mb-4 section" v-if="$route.query.flag == 'light'">
        <div class="col-3 g-4">
          <!-- lantern information -->
          <div class="large-card">
            <div class="row">
              <!-- lantern image -->
              <div class="col-lg-3">
                <svg
                  width="63"
                  height="63"
                  viewBox="0 0 63 63"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    width="63"
                    height="63"
                    rx="31.5"
                    fill="url(#paint0_linear_1217_8081)"
                  />
                  <path
                    d="M36.7066 12.5L35.8244 14.9783H43.5L42.6177 12.5H36.7066ZM27.6635 12.9957C25.3696 12.9957 23.6757 13.749 22.6435 14.9155C21.6042 16.0811 21.223 17.5804 21.223 19.0261V42.2391H22.8111V19.0261C22.8111 17.8283 23.1375 16.6841 23.861 15.8671C24.5933 15.051 25.7225 14.4826 27.6635 14.4826H36.0008L36.5302 12.9957H27.6635ZM19.9482 42.2391L19.5 50.5H24.5315L24.0816 42.2391H19.9482Z"
                    fill="#218863"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_1217_8081"
                      x1="1.5"
                      y1="1.33853"
                      x2="53.4663"
                      y2="66.9267"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0.29" stop-color="#BCEFDB" />
                      <stop offset="1" stop-color="#A0CCE7" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
              <!--  -->
              <div class="col-lg-9">
                <p
                  style="
                    font-family: Poppins;
                    font-weight: 600;
                    font-size: 16px;
                    line-height: 100%;
                    letter-spacing: 0%;
                    padding-top: 7%;
                  "
                >
                  Lantern Information
                </p>
              </div>
            </div>
            <div class="row" v-for="(item, index) in lanternInfo" :key="index">
              <div class="col-lg-5">
                <p
                  style="
                    font-family: Poppins;
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 30px;
                    letter-spacing: 0%;
                    color: #ababab;
                  "
                >
                  {{ item.label }}
                </p>
              </div>

              <div class="col-lg">
                <p
                  style="
                    font-family: Poppins;
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 30px;
                    letter-spacing: 0%;
                    color: #ababab;
                  "
                >
                  : {{ item.value }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-3 g-4">
          <!-- co2 emmission -->
          <div
            class="h-100 row justify-content-start align-content-start align-items-start"
          >
            <div class="col-12 m-0 g-4">
              <div class="large-card p-0">
                <div
                  style="padding-top: 10%"
                  class="position-relative d-flex flex-column justify-content-center align-items-center"
                >
                  <div class="total-cost_icon">
                    <svg
                      width="142"
                      height="142"
                      viewBox="0 0 142 142"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        width="142"
                        height="142"
                        rx="71"
                        fill="url(#paint0_linear_1217_8056)"
                      />
                      <path
                        d="M52.8277 100C47.8167 100 43.536 98.0969 39.9854 94.2906C36.4348 90.4844 34.6585 85.8323 34.6562 80.3344C34.6562 75.6219 35.9503 71.4229 38.5383 67.7375C41.1264 64.0521 44.5129 61.6958 48.6978 60.6687C50.0744 55.1104 52.8277 50.6094 56.9575 47.1656C61.0874 43.7219 65.7679 42 70.9991 42C77.4416 42 82.9074 44.4626 87.3963 49.3878C91.8851 54.3129 94.1285 60.3087 94.1263 67.375C97.9258 67.8583 101.079 69.6563 103.585 72.769C106.092 75.8817 107.344 79.5212 107.342 83.6875C107.342 88.2188 105.897 92.0709 103.007 95.244C100.117 98.4171 96.6064 100.002 92.4743 100H52.8277Z"
                        fill="#218863"
                      />
                      <path
                        d="M51.86 77.02C51.86 75.66 52.1667 74.44 52.78 73.36C53.3933 72.2667 54.2267 71.4133 55.28 70.8C56.3467 70.1867 57.5267 69.88 58.82 69.88C60.34 69.88 61.6667 70.2467 62.8 70.98C63.9333 71.7133 64.76 72.7533 65.28 74.1H63.1C62.7133 73.26 62.1533 72.6133 61.42 72.16C60.7 71.7067 59.8333 71.48 58.82 71.48C57.8467 71.48 56.9733 71.7067 56.2 72.16C55.4267 72.6133 54.82 73.26 54.38 74.1C53.94 74.9267 53.72 75.9 53.72 77.02C53.72 78.1267 53.94 79.1 54.38 79.94C54.82 80.7667 55.4267 81.4067 56.2 81.86C56.9733 82.3133 57.8467 82.54 58.82 82.54C59.8333 82.54 60.7 82.32 61.42 81.88C62.1533 81.4267 62.7133 80.78 63.1 79.94H65.28C64.76 81.2733 63.9333 82.3067 62.8 83.04C61.6667 83.76 60.34 84.12 58.82 84.12C57.5267 84.12 56.3467 83.82 55.28 83.22C54.2267 82.6067 53.3933 81.76 52.78 80.68C52.1667 79.6 51.86 78.38 51.86 77.02ZM74.3092 84.14C73.0159 84.14 71.8359 83.84 70.7692 83.24C69.7026 82.6267 68.8559 81.78 68.2292 80.7C67.6159 79.6067 67.3092 78.38 67.3092 77.02C67.3092 75.66 67.6159 74.44 68.2292 73.36C68.8559 72.2667 69.7026 71.42 70.7692 70.82C71.8359 70.2067 73.0159 69.9 74.3092 69.9C75.6159 69.9 76.8026 70.2067 77.8692 70.82C78.9359 71.42 79.7759 72.26 80.3892 73.34C81.0026 74.42 81.3092 75.6467 81.3092 77.02C81.3092 78.3933 81.0026 79.62 80.3892 80.7C79.7759 81.78 78.9359 82.6267 77.8692 83.24C76.8026 83.84 75.6159 84.14 74.3092 84.14ZM74.3092 82.56C75.2826 82.56 76.1559 82.3333 76.9292 81.88C77.7159 81.4267 78.3292 80.78 78.7692 79.94C79.2226 79.1 79.4492 78.1267 79.4492 77.02C79.4492 75.9 79.2226 74.9267 78.7692 74.1C78.3292 73.26 77.7226 72.6133 76.9492 72.16C76.1759 71.7067 75.2959 71.48 74.3092 71.48C73.3226 71.48 72.4426 71.7067 71.6692 72.16C70.8959 72.6133 70.2826 73.26 69.8292 74.1C69.3892 74.9267 69.1692 75.9 69.1692 77.02C69.1692 78.1267 69.3892 79.1 69.8292 79.94C70.2826 80.78 70.8959 81.4267 71.6692 81.88C72.4559 82.3333 73.3359 82.56 74.3092 82.56ZM82.7839 87.124C83.7999 86.308 84.5959 85.64 85.1719 85.12C85.7479 84.592 86.2319 84.044 86.6239 83.476C87.0239 82.9 87.2239 82.336 87.2239 81.784C87.2239 81.264 87.0959 80.856 86.8399 80.56C86.5919 80.256 86.1879 80.104 85.6279 80.104C85.0839 80.104 84.6599 80.276 84.3559 80.62C84.0599 80.956 83.8999 81.408 83.8759 81.976H82.8199C82.8519 81.08 83.1239 80.388 83.6359 79.9C84.1479 79.412 84.8079 79.168 85.6159 79.168C86.4399 79.168 87.0919 79.396 87.5719 79.852C88.0599 80.308 88.3039 80.936 88.3039 81.736C88.3039 82.4 88.1039 83.048 87.7039 83.68C87.3119 84.304 86.8639 84.856 86.3599 85.336C85.8559 85.808 85.2119 86.36 84.4279 86.992H88.5559V87.904H82.7839V87.124Z"
                        fill="#BCEFDB"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_1217_8056"
                          x1="3.38095"
                          y1="3.017"
                          x2="120.511"
                          y2="150.851"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0.29" stop-color="#BCEFDB" />
                          <stop offset="1" stop-color="#A0CCE7" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                  <h1 class="total-cost_value">{{ co2emmission }} Kg</h1>

                  <p
                    class="total-cost_label_small"
                    style="color: #ababab; text-align: center"
                  >
                    This year estimated <br />
                    Co<sub>2</sub> Emissions Reduction
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 g-4">
          <div class="large-card">
            <VoltageChart :items="voltageChart" />
          </div>
        </div>
      </div>
      <div class="row mb-4 section" v-if="$route.query.flag == 'light'">
        <div class="col-6">
          <div class="large-card">
            <CurrentChart :items="currentChart" />
          </div>
        </div>
        <div class="col-6">
          <div class="large-card">
            <EnergyChart :items="energyChart" />
          </div>
        </div>
      </div>
    </div>
    <!-- <div
      class="modal fade"
      id="lightModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="lightModal"
      data-bs-backdrop="static"
      aria-hidden="true"
    >
      <ListLightModal ref="lightModal" @close-modal="closeLightModal" />
    </div> -->
    <!-- <div
      class="modal fade"
      id="clusterMapModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="clusterMapModal"
      data-bs-backdrop="static"
      aria-hidden="true"
    >
      <ClusterMapModal
        ref="clusterMapModal"
        @close-modal="closeClusterMapModal"
      />
    </div> -->
  </div>
</template>
<script>
// import { useTemplateRef } from 'vue'
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { Modal } from "bootstrap";
// import ClusterMaster from "./cluster/ClusterMaster.vue";
import CurrentChart from "./cluster/currentChart.vue";
import EnergyChart from "./cluster/energyChart.vue";
// import EventLogs from "./cluster/EventLogs.vue";
import LeftCards from "./cluster/LeftCards.vue";
// import ListLightModal from "./cluster/ListLightModal.vue";
import RightCards from "./cluster/RightCards.vue";
import TotalCost from "./cluster/TotalCost.vue";
import VoltageChart from "./cluster/voltageChart.vue";
// import ClusterMap from "./maps/maps/clusterMap.vue";
import markerData from "../data/api/listMarker.json";
// import ClusterMapModal from "./cluster/ClusterMapModal.vue";
import Doughnut from "@/components/chart/doughnut.vue";
import { DOUGHNUT_COLORS } from "@/constants";
import moment from "moment";
import downloadIcon from "@/assets/svg/download-icon.vue";
import roundIcon from "@/assets/svg/round-icon.vue";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { formatTo2Decimal, getCookies, setCookies } from "@/utils";

// clusterAnalytic

export default {
  components: {
    TotalCost,
    LeftCards,
    RightCards,
    // EventLogs,
    CurrentChart,
    EnergyChart,
    VoltageChart,
    // ClusterMap,
    // ClusterMaster,
    // ListLightModal,
    // ClusterMapModal,
    Datepicker,
    Doughnut,
    downloadIcon,
    roundIcon,
  },
  computed: {
    lightPage() {
      //return Boolean(this.$route.query.clusterId);
      if (this.$route.query.flag == "cluster") {
        return false;
      } else {
        return true;
      }
    },
  },
  data() {
    return {
      loading: false,
      tariff: "",
      rangeSelected: "Daily",
      rangeOptions: ["Daily", "Weekly", "Monthly"],
      costSaving: "",
      dateRange: [],
      lightOperatingHours: [],
      operatingHours: [],
      lightData: [10, 20, 40, 20, 30, 40, 10, 30, 50, 70],
      cards: [],
      markers: [],
      lightModal: null,
      clusterMapModal: null,
      volatgeChart: {
        Label: [],
        Data: [],
      },
      currentChart: {
        Label: [],
        Data: [],
      },
      energyChart: {
        Label: [],
        Data: [],
      },
      co2emmission: "",
      lanternInfo: [],
      headername: "",
    };
  },

  mounted() {
    // console.log(this.$route.query.flag);

    // set initial value
    this.getStartAndEndDateForCurrentMonth();
    // this.rangeSelected = "Daily";

    this.setStyleDatepicker();
    // this.lightModal = new Modal(document.getElementById("lightModal"), {});
    // const lightModalElement = document.getElementById("lightModal");
    // lightModalElement.addEventListener("show.bs.modal", () => {
    //   this.$refs.lightModal.initializeModal();
    // });

    this.getMarkers();
    // this.clusterMapModal = new Modal(
    //   document.getElementById("clusterMapModal"),
    //   {}
    // );
    // const clusterMapModalElement = document.getElementById("clusterMapModal");
    // clusterMapModalElement.addEventListener("show.bs.modal", () => {
    //   this.$refs.clusterMapModal.initializeModal(this.markers);
    // });
    DOUGHNUT_COLORS.forEach((val, index) => {
      this.lightOperatingHours.push({
        color: val,
        value: `${10 * (index + 1)}%`,
      });
    });
    // if (this.$route.query.clusterId) {
    //   this.cards = [
    //     {
    //       img: "energy",
    //       title: "856.68 kWh",
    //       subtitle: "Energy Savings",
    //     },
    //     {
    //       img: "energy",
    //       title: "30%",
    //       subtitle: "Percentage Energy Savings",
    //     },
    //   ];
    // } else {
    //   this.cards = [
    //     {
    //       img: "energy",
    //       title: "856.68 kWh",
    //       subtitle: "Energy Savings",
    //     },
    //     {
    //       img: "co2",
    //       title: "1,998.80 Kg",
    //       subtitle: "Co2 Emissions Reduction",
    //     },
    //     {
    //       img: "energy",
    //       title: "30%",
    //       subtitle: "Percentage Energy Savings",
    //     },
    //     {
    //       img: "uprate",
    //       title: "95.5%",
    //       subtitle: "Communication Uprate",
    //     },
    //   ];
    // }
  },
  methods: {
    async downloadPDF() {
      this.loading = true;
      const sections = document.querySelectorAll(".section");
      // console.log("koko")
      const pdf = new jsPDF({
        unit: "mm",
        format: "a4",
        orientation: "portrait",
      });

      // console.log(sections)
      let imageheight = 3;
      for (let i = 0; i < sections.length; i++) {
        const canvas = await html2canvas(sections[i], { scale: 2 });
        const imgData = canvas.toDataURL("image/png");

        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        // console.log(pdfHeight + imageheight)
        // if (i == 0) pdf.addPage();
        pdf.addImage(imgData, "PNG", 3, imageheight, pdfWidth, pdfHeight);

        if ((i + 1) % 4 === 0) {
          pdf.addPage();
        }

        imageheight += 50;
      }

      pdf.save("Analytic.pdf");
      // console.log(pdf)

      this.loading = false;
      // const element = this.$refs.pdfContent;

      // const options = {
      //   margin:       10,
      //   filename:     'full-page.pdf',
      //   image:        { type: 'jpeg', quality: 0.98 },
      //   html2canvas:  { scale: 2, useCORS: true },
      //   jsPDF:        { unit: 'mm', format: 'a4', orientation: 'landscape' },
      //   pagebreak:    { mode: ['avoid-all', 'css', 'legacy'] }
      // };

      // html2pdf().set(options).from(element).save();
    },
    setStyleDatepicker() {
      setTimeout(() => {
        const div = document.querySelectorAll(".datepicker-here > div");
        if (div.length > 0) {
          div.forEach((element) => {
            element.style.flex = "none";
            element.style.width = "100%";
          });
        }
      }, 0);
    },
    handleDate() {
      // console.log("handle date called");
      this.setStyleDatepicker();
      this.getAnalytics();
    },
    getAnalytics() {
      let start = moment(this.dateRange[0]).format("YYYY-MM-DD");
      let end = moment(this.dateRange[1]).format("YYYY-MM-DD");

      let range = this.rangeSelected.toLowerCase();

      this.$http
        .get(
          ":11000/api/v1/" +
            this.$route.query.flag +
            "/analytics/" +
            this.$route.query.id +
            "?startDate=" +
            start +
            "&endDate=" +
            end +
            "&agg=" +
            range
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;

            if (this.lightPage) {
              this.headername = response.DeviceName;
            } else {
              this.headername = response.ClusterName;
            }

            this.setHeaderComponent();

            this.cards = [];
            this.voltageChart = {};
            this.voltageChart = {};
            this.energyChart = {};

            this.operatingHours = [];

            // total cost saving
            this.costSaving = response.CostSavings.toFixed(2);
            this.tariff =
              this.$route.query.flag == "cluster"
                ? response.TariffRate.toFixed(2)
                : null;

            // total energy saving and percentage energy saving
            if (this.$route.query.flag == "cluster") {
              this.cards = [
                {
                  img: "energy",
                  title: response.EnergySavings.toFixed(2) + " kWh",
                  subtitle: "Energy Savings",
                },
                {
                  img: "co2",
                  title: response.CO2Reduction.toFixed(2) + " Kg",
                  subtitle: "Co2 Emissions Reduction",
                },
                {
                  img: "energy",
                  title: response.PercentageEnergySavings.toFixed(2) + "%",
                  subtitle: "Percentage Energy Savings",
                },
                {
                  img: "uprate",
                  title: response.CommunicationUprate.toFixed(2) + "%",
                  subtitle: "Communication Uprate",
                },
              ];
            } else {
              this.cards = [
                {
                  img: "energy",
                  title: response.EnergySavings.toFixed(2) + " kWh",
                  subtitle: "Energy Savings",
                },
                {
                  img: "energy",
                  title: response.PercentageEnergySavings.toFixed(2) + " %",
                  subtitle: "Percentage Energy Savings",
                },
              ];
            }

            // light operating hours
            for (var i = 0; i < response.LightOperatingHours.length; i++) {
              this.operatingHours.push(response.LightOperatingHours[i].Minutes);
            }

            // co2 emission for light analytic
            if (this.$route.query.flag == "light") {
              this.co2emmission = "1998.80";
            }

            // lantern information for lights
            if (this.$route.query.flag == "light") {
              this.lanternInfo = [
                {
                  label: "Make",
                  value: response.LanternInformation.Make,
                },
                {
                  label: "Model",
                  value: response.LanternInformation.Model,
                },
                {
                  label: "Serial No.",
                  value: response.LanternInformation.SerialNo,
                },
                {
                  label: "Date Installed",
                  value: moment(
                    response.LanternInformation.DateInstalled
                  ).format("DD / MM / YYYY"),
                },
              ];
            }

            // voltage chart
            this.voltageChart = {
              Label: response.GraphData.GraphVoltage.Period.map((date) => {
                if (this.rangeSelected === "Daily") {
                  return moment(date).format("YYYY-MM-DD");
                } else if (this.rangeSelected === "Monthly") {
                  return moment(date).format("MMM");
                } else {
                  return (
                    "Week " +
                    moment(date).week() +
                    " - " +
                    moment(date).format("YYYY-MM-DD")
                  );
                }
              }),
              Data: formatTo2Decimal(response.GraphData.GraphVoltage.AvgGraph),
            };

            // current chart
            this.currentChart = {
              Label: response.GraphData.GraphCurrent.Period.map((date) => {
                if (this.rangeSelected === "Daily") {
                  return moment(date).format("YYYY-MM-DD");
                } else if (this.rangeSelected === "Monthly") {
                  return moment(date).format("MMM");
                } else {
                  return (
                    "Week " +
                    moment(date).week() +
                    " - " +
                    moment(date).format("YYYY-MM-DD")
                  );
                }
              }),
              Data: formatTo2Decimal(response.GraphData.GraphCurrent.AvgGraph),
            };

            // energy chart
            this.energyChart = {
              Label: response.GraphData.GraphEnergy.Period.map((date) => {
                if (this.rangeSelected === "Daily") {
                  return moment(date).format("YYYY-MM-DD");
                } else if (this.rangeSelected === "Monthly") {
                  return moment(date).format("MMM");
                } else {
                  return (
                    "Week " +
                    moment(date).week() +
                    " - " +
                    moment(date).format("YYYY-MM-DD")
                  );
                }
              }),
              Data: formatTo2Decimal(response.GraphData.GraphEnergy.AvgGraph),
            };
          }
        });
    },
    formatDateRange(dateRange) {
      if (Array.isArray(dateRange)) {
        return dateRange.map(this.formatDate).join(" - ");
      }
      return "";
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    getStartAndEndDateForCurrentMonth() {
      this.dateRange = [moment().startOf("w"), moment().endOf("w")];
    },
    // getStartAndEndDateForCurrentMonth() {
    //   return [moment().startOf("w"), moment().endOf("w")]
    //   const now = new Date();
    //   const year = now.getFullYear();
    //   const month = now.getMonth() + 1;
    //   const endDate = new Date(year, month, 0);
    //   const formattedStartDate = `${year}-${String(month).padStart(2, "0")}-01`;
    //   const formattedEndDate = `${year}-${String(month).padStart(
    //     2,
    //     "0"
    //   )}-${String(endDate.getDate()).padStart(2, "0")}`;
    //   return [new Date(formattedStartDate), new Date(formattedEndDate)];
    // },
    titleHTML(card) {
      if (!card) return;
      if (!card.title.includes("{value}")) {
        return `<strong>${card.title}</strong>`;
      }
      return card.title.replace(
        "{value}",
        `<strong>${card.value}</strong>` || 0
      );
    },
    openLightModal() {
      this.lightModal.show();
    },
    closeLightModal() {
      this.lightModal.hide();
    },
    openClusterMapModal() {
      this.clusterMapModal.show();
    },
    closeClusterMapModal() {
      this.clusterMapModal.hide();
    },
    getMarkers() {
      this.markers = markerData.message.markers.map((item) => {
        return {
          ...item,
          latLng: [item.lat, item.long],
        };
      });
    },
    setHeaderComponent() {
      const version = getCookies("version");
      if (version === "2") {
        setCookies("redirect", "true");
      }

      this.$store.dispatch("common/setHeaderComponent", {
        title: this.lightPage
          ? "Analytic Light Page - " + this.headername
          : "Analytic Cluster Page - " + this.headername,
        subtitle: "",
        showBack: true,
        backUrl: this.lightPage
          ? "/light?id=" +
            this.$route.query.id +
            "&clusterId=" +
            this.$route.query.clusterId
          : "/cluster?id=" + this.$route.query.id,
      });
    },
  },
  watch: {
    dateRange() {
      this.getAnalytics();
    },
    rangeSelected() {
      // console.log("panggil");
      this.getAnalytics();
    },
    // printSection() {
    //   window.print();
    //   window.close();
    // },
  },
};
</script>

<style lang="scss" scoped>
.doughnut-legend {
  margin-left: 7px;
  color: #ababab;
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.total-cost {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background: linear-gradient(142deg, #bcefdb 41.95%, #a0cce7 96.79%);
  box-shadow: 0px 4px 8px 0px rgba(215, 227, 235, 0.25);

  &_icon {
    width: 142px;
    height: 142px;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    border-radius: 100px;
    margin-bottom: 30px;
    background: radial-gradient(50% 50% at 50% 50%, #e2fef2 0%, #8bd9ba 100%);
    box-shadow: 4px 4px 8px 0px rgba(226, 254, 242, 0.2);
  }

  &_value {
    color: #000;
    text-align: center;
    font-family: Poppins;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin: 0;
  }

  &_label {
    color: #218863;
    font-family: Poppins;
    font-size: 25px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin: 0;

    &_small {
      font-size: 16px;
    }
  }
}

.dp__theme_light {
  --dp-background-color: #fff;
  --dp-text-color: #9b9a9a;
}

.datepicker-here {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 51px;
  color: #9b9a9a;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border: none;
  padding: 16px 2px;
  width: 310px;
  text-align: left;
  border-radius: 8px;
  background: #fff;

  &:active {
    border: none;
  }

  &::after {
    color: #0492ff;
  }
}

h2 {
  color: #009a78;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 32px;
}

.cluster-page {
  padding: 10px;
  // padding-top: 68px;
}

.fixed-content {
  height: 68px;
  position: fixed;
  z-index: 2;
  width: calc(100% - 86px);
  // right: 24px;
  top: 137px;
  padding: 0;
  background: #f5f6fa;

  .btnAnalytics {
    display: flex;
    height: 44px;
    padding: 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 5px;
    border: 1px solid #218863;
    text-align: center;
    font-family: Poppins;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  .reportBtn {
    width: 210px;
    color: #fff;
    background: #218863;
  }
}

.btnAnalytics {
  // display: flex;
  position: absolute;
  right: 10px;
  height: 44px;
  // padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 5px;
  border: 1px solid #218863;
  text-align: center;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.reportBtn {
  width: 210px;
  color: #fff;
  background: #218863;
}
</style>
<style lang="scss">
.info {
  width: 25px;
  height: 25px;
  background: #fff;
  border: 2px solid #1daeef;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 15px;
  top: 15px;
  color: #1daeef;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  cursor: pointer;
}

.large-card {
  height: 353px;
  padding: 35px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 4px 8px 0px rgba(215, 227, 235, 0.25);

  .green {
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(142deg, #bcefdb 41.95%, #a0cce7 96.79%);
    box-shadow: 0px 4px 8px 0px rgba(215, 227, 235, 0.25);
  }
}

.card-small {
  height: 160px !important;
  border-radius: 8px !important;
  background: #fff !important;
  box-shadow: 0px 4px 8px 0px rgba(215, 227, 235, 0.25) !important;

  .card-body {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 19px 15px 19px 35px !important;
  }

  .card-footer {
    padding: 13px 16px !important;
    color: #1daeef;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    span {
      cursor: pointer;
    }
  }

  .widget-content {
    display: flex;
    align-items: center;
    gap: 15px;
  }

  .image {
    min-width: 63px;
    min-height: 63px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background: var(
      --Gradient,
      linear-gradient(142deg, #bcefdb 29.66%, #a0cce7 96.79%)
    );

    img {
      scale: 0.667;
      object-fit: contain;
    }
  }

  .title {
    margin: 0;
    color: #ababab;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    white-space: pre-line;

    strong {
      color: #000;
      text-shadow: 0px 4px 8px rgba(215, 227, 235, 0.25);
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
    }

    p {
      color: #009a78;
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin: 0;
    }
  }

  .subtitle {
    margin: 0;
    color: #ababab;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    white-space: pre-line;
  }

  .card-footer {
    border-top: 1px solid #e9e9e9;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 60px;
  }
}

.fixed-content {
  position: fixed;
  top: 114px;
  left: 112px;
  height: 51px;
  width: auto;
  z-index: 8;
}

.dropdown .dropdown-toggle {
  position: relative;
  width: 215px !important;
  // padding: 0 15px;
  border-radius: 8px;
  border: none;
  background: #fff !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  color: #9b9a9a !important;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  &:hover {
    border: 1px solid #218863;
  }

  &::after {
    color: #218863;
    right: 15px;
  }
}
</style>
